import {useUpliftAdsImpressionTracking} from '@travel-frontend/ui-components';
import {useRef} from 'react';

import {Base} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Base';
import {Wrapper} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Wrapper';

type Props = {
  category: string;
  content: Record<string, string>;
  impressionUrl: string;
  viewableImpressionUrl: string;
  width?: string;
  height?: string;
  className: string;
  onClick: () => void;
};

export const Banner: React.FunctionComponent<Props> = ({
  category,
  content,
  impressionUrl,
  viewableImpressionUrl,
  width,
  height,
  className,
  onClick,
  ...props
}) => {
  const element = useRef<HTMLDivElement | null>(null);

  useUpliftAdsImpressionTracking({
    element,
    impressionUrl,
    viewableImpressionUrl,
  });

  return (
    <Wrapper
      ref={element}
      width={width}
      height={height}
      className={className}
      onClick={onClick}
    >
      <Base {...props} category={category} content={content} />
    </Wrapper>
  );
};
